<ng-container [ngSwitch]="formModel.type" [formGroup]="form">

  <div>
    <div app-info-icon [openEvent]="everyFocus" [closeEvent]="closeInfoWindow" class="info-button" [formModel]="formModel" [extraImage]="formModel.getExtraInfoImage()" *ngIf="formModel.hasInfotext() && inlineHelp === false" [headlinePostfix]="formConfig.getLabelPostfix()" [headlineFallback]="getLabel()" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></div>

    <ng-container *ngSwitchCase="'hidden'">
      <input type="hidden" [id]="formModel.id" [formControlName]="formModel.id" [value]="formModel.getValue()">
    </ng-container>

    <ng-container *ngSwitchCase="'text'">
      <label [for]="formModel.id">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="input-group" [class.text-label]="formModel.getUnit() != null" [class.focus]="focus[formModel.id]" [class.error]="isInvalid()" [class.warning]="isWarning()" [class.presetted]="formModel.getPresetMark()">
        <input
          [type]="formModel.fieldData['fieldType'] === 'number'? 'text' : formModel.fieldData['fieldType']"
          [attr.inputmode]="formModel.fieldData['fieldType'] === 'number'? 'decimal' : null"
          [readOnly]="formModel.fieldData['readonly']"
          [id]="formModel.id"
          [formControlName]="formModel.id"
          [value]="formModel.getValue()"
          [required]="formModel.isRequired()"
          [placeholder]="getLabel() | translate" (focus)="onFocus()"
          (blur)="onBlur()"
          (paste)="formModel.fieldData['fieldType'] === 'number'? onPasteCheckNumber($event) : null"
          (keyup)="formModel.fieldData['fieldType'] === 'number'? onKeyUpCheckNumber($event) : null"
          class="input-group-field"
          onwheel="this.blur()"
          [attr.aria-describedby]="formModel.getUnit() ? (formModel.id + '_unit') : null"
        >
        @if (formModel.fieldData['fieldType'] === 'number') {
          <span class="input-hint" [class.hidden]="!hasInputHint" [innerHTML]="'input.hint.dot' | translate"></span>
        }
        <abbr [id]="formModel.id + '_unit'" [title]="(formModel.getUnit() ? ('arialabel.' + formModel.getUnit()) : '') | translate" class="input-group-label" *ngIf="formModel.getUnit() != null">{{ 'unit.' + formModel.getUnit() | translate }}</abbr>
        <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'textselect'">
      <label [for]="formModel.id">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="grid-x type-textselect" [class.error]="isInvalid()" [class.warning]="isWarning()" [class.presetted]="formModel.getPresetMark()">
        <div class="small-7 cell">
          <input
            [type]="formModel.fieldData['fieldType'] === 'number'? 'text' : formModel.fieldData['fieldType']"
            [attr.inputmode]="formModel.fieldData['fieldType'] === 'number'? 'decimal' : null"
            [id]="formModel.id" [formControlName]="formModel.id"
            [value]="formModel.fieldData['values'][0]"
            [required]="formModel.isRequired()"
            [placeholder]="getLabel() | translate" (focus)="onFocus()"
            (paste)="formModel.fieldData['fieldType'] === 'number'? onPasteCheckNumber($event) : null"
            (keyup)="formModel.fieldData['fieldType'] === 'number'? onKeyUpCheckNumber($event) : null"
            class="input-group-field"
            onwheel="this.blur()"
            [attr.aria-describedby]="formModel.fieldData['secondId']"
          >
          @if (formModel.fieldData['fieldType'] === 'number') {
            <span class="input-hint" [class.hidden]="!hasInputHint" [innerHTML]="'input.hint.dot' | translate"></span>
          }
        </div>
        <div class="small-5 cell">
          <select [attr.aria-label]="'arialabel.choose.unit' | translate" [id]="formModel.fieldData['secondId']" [formControlName]="formModel.fieldData['secondId']">
            <option *ngFor="let option of formModel.getOptions(); let i = index" [attr.aria-label]="'arialabel.' + option | translate" [value]="option">{{ 'unit.' + option | translate }}</option>
          </select>
          <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
        </div>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'doubletext-select'">
      <strong [id]="formModel.id + '-doubletext-select'" class="input-group-headline field-group-label">{{ getFieldGroupLabel() | translate }}</strong>
      <p *ngIf="teaserTextkey" [innerHTML]="'teaserTextkey' | translate"></p>
      <div [attr.aria-labelledby]="formModel.id + '-doubletext-select'" class="grid-x type-double-textselect" [class.error]="isInvalid()" [class.warning]="isWarning()" [class.presetted]="formModel.getPresetMark()">
        <div class="small-4 cell">
          <label [for]="formModel.id" *ngIf="formModel.getUnit() != null">{{ 'unit.' + formModel.getUnit() | translate }}</label>
          <input
            [type]="formModel.fieldData['fieldType'] === 'number'? 'text' : formModel.fieldData['fieldType']"
            [attr.inputmode]="formModel.fieldData['fieldType'] === 'number'? 'decimal' : null"
            [id]="formModel.id" [formControlName]="formModel.id"
            [value]="formModel.fieldData['values'][0]"
            [required]="formModel.isRequired()"
            [placeholder]="getLabel() | translate" (focus)="onFocus()"
            (paste)="formModel.fieldData['fieldType'] === 'number'? onPasteCheckNumber($event) : null"
            (keyup)="formModel.fieldData['fieldType'] === 'number'? onKeyUpCheckNumber($event) : null"
            class="input-group-field"
            onwheel="this.blur()"
          >
          @if (formModel.fieldData['fieldType'] === 'number') {
            <span class="input-hint" [class.hidden]="!hasInputHint" [innerHTML]="'input.hint.dot' | translate"></span>
          }
        </div>
        <div class="small-4 cell">
          <label [for]="formModel.fieldData.secondId" *ngIf="formModel.getSecondUnit() != null">{{ 'unit.' + formModel.getSecondUnit() | translate }}</label>
          <input
            [type]="formModel.fieldData['fieldType'] === 'number'? 'text' : formModel.fieldData['fieldType']"
            [attr.inputmode]="formModel.fieldData['fieldType'] === 'number'? 'decimal' : null"
            [id]="formModel.fieldData.secondId" [formControlName]="formModel.fieldData.secondId"
            [value]="formModel.fieldData['values'][0]"
            [required]="formModel.isRequired()"
            [placeholder]="formConfig.getLabel(step, formModel.fieldData.secondId) | translate" (focus)="onFocus()"
            (paste)="formModel.fieldData['fieldType'] === 'number'? onPasteCheckNumber($event) : null"
            (keyup)="formModel.fieldData['fieldType'] === 'number'? onKeyUpCheckNumber($event) : null"
            class="input-group-field"
            onwheel="this.blur()"
          >
        </div>
        <div class="small-4 cell">
          <select [attr.aria-label]="'arialabel.choose.interval' | translate" [id]="formModel.fieldData['selectId']" [formControlName]="formModel.fieldData['selectId']">
            <option *ngFor="let option of formModel.getOptions(); let i = index" [value]="option">{{ 'unit.' + option | translate }}</option>
          </select>
          <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
        </div>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'number'">
      <label [for]="formModel.id">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="input-group type-number" [class.error]="isInvalid()" [class.focus]="focus[formModel.id]">
        <div class="input-group-button">
          <button (click)="decreaseValue()" type="button" [attr.aria-label]="'arialabel.minus' | translate"><i class="icon-minus-circle"></i></button>
        </div>
        <input [type]="formModel.type" onwheel="this.blur()" class="input-group-field" [id]="formModel.id" [formControlName]="formModel.id" [class.error]="isInvalid()" [class.warning]="isWarning()" [value]="formModel.getValue()" [required]="formModel.isRequired()" [placeholder]="getLabel() | translate" (focus)="onFocus()" (blur)="onBlur()">
        <div class="input-group-button">
          <button (click)="increaseValue()" type="button" [attr.aria-label]="'arialabel.plus' | translate"><i class="icon-plus-circle"></i></button>
        </div>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'radio'">
      <strong [id]="formModel.id + '-grouped-label'" class="input-group-headline"  >{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</strong>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <mat-radio-group [attr.aria-label]="(getLabel() | translate) + (getExtraLabelText()? (getExtraLabelText() | translate) : '')" [formControlName]="formModel.id" [class.icons]="formModel.fieldData.iconPath">
        <ng-container *ngFor="let option of formModel.getOptions()">
          <mat-radio-button [aria-describedby]="formModel.id + '-grouped-label'" [value]="option" [name]="formModel.id" color="primary" [required]="formModel.isRequired()" [disabled]="formModel.isOptionDisabled(option)">
            <app-advisor-image *ngIf="formModel.fieldData.iconPath" [path]="formModel.fieldData.iconPath + option  + '.svg'" altText=""></app-advisor-image>
            <span [innerHTML]="getOptionLabel(option) | translate"></span>
          </mat-radio-button>
          <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="option + formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
        </ng-container>

      </mat-radio-group>
    </ng-container>

    <ng-container *ngSwitchCase="'select'">
      <label [for]="formModel.id">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="type-select" [class.error]="isInvalid()" [class.warning]="isWarning()" [class.presetted]="formModel.getPresetMark()">
        <select [id]="formModel.id" [name]="formModel.id" [required]="formModel.isRequired()" [formControlName]="formModel.id">
          <option *ngFor="let option of formModel.getOptions()" [value]="option" [selected]="option === formModel.getValue()">{{ getOptionLabel(option) | translate }}</option>
        </select>
        <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'dates'">
      <label [for]="formModel.fieldData['ids'][0]">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="grid-x type-dates" [class.presetted]="formModel.getPresetMark()">

        <div class="cell auto">
          <input type="text" pattern="[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{2,4}" [class.error]="isInvalidFirstField()" [class.warning]="isWarning()" [id]="formModel.fieldData['ids'][0]" [class.focus]="focus[formModel.fieldData['ids'][0]]" [formControlName]="formModel.fieldData['ids'][0]" [value]="formModel.getValue()" [required]="formModel.isRequired()" placeholder="TT.MM.JJJJ" (focus)="onFocus()" (blur)="onBlur(); presetFields()">
        </div>
        <div class="cell shrink">
          <label class="middle" [for]="formModel.fieldData['ids'][1]">{{ 'dateicker.to' | translate }}</label>
        </div>
        <div class="cell auto">
          <input type="text" pattern="[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{2,4}" [class.error]="isInvalidSecondField()" [class.warning]="isWarning()" [id]="formModel.fieldData['ids'][1]" [class.focus]="focus[formModel.fieldData['ids'][1]]" [formControlName]="formModel.fieldData['ids'][1]" [value]="formModel.getValue()" [required]="formModel.isRequired()" placeholder="TT.MM.JJJJ" (focus)="onFocus()" (blur)="onBlur()">
        </div>

        <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'date'">
      <label [for]="formModel.id">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="input-group" [class.focus]="focus[formModel.id]" [class.error]="isInvalid()" [class.warning]="isWarning()">
        <input type="text" pattern="[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{4}" [readOnly]="formModel.fieldData['readonly']" class="input-group-field" [id]="formModel.id" [formControlName]="formModel.id" [value]="formModel.getValue()" [required]="formModel.isRequired()" placeholder="TT.MM.JJJJ" (focus)="onFocus()" (blur)="onBlur()">
        <span class="input-group-label" *ngIf="formModel.getUnit() != null">{{ 'unit.' + formModel.getUnit() | translate }}</span>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'checkboxes'">
      <strong [id]="formModel.id + '-grouped-label'" class="input-group-headline">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</strong>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <ng-container *ngFor="let option of formModel.getOptions()">
        <div class="input-checkbox">
          <mat-checkbox [aria-describedby]="formModel.id + '-grouped-label'" [value]="formModel.getValue()" [formControlName]="formModel.id + '_' + option" [checked]="formModel.getValue()" [required]="formModel.isRequired()" color="primary" [disabled]="formModel.isOptionDisabled(option)">{{ getOptionLabel(option) | translate }}</mat-checkbox>
          <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="option"></app-info-callout>
        </div>
      </ng-container>

    </ng-container>

    <ng-container *ngSwitchCase="'percent'">
      <label [for]="formModel.id">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="slider-wrapper" [class.presetted]="formModel.getPresetMark()">
        <div class="label">
          <span>{{ getLabel(formModel.fieldData['ids'][0]) | translate }}</span>
          <span>{{ getLabel(formModel.fieldData['ids'][1]) | translate }}</span>
        </div>
        <div class="values">
          <span [style.left]="getValue(formModel.fieldData['ids'][0]) / 2 + '%'">{{getValue(formModel.fieldData['ids'][0])}} %</span>
          <span [style.right]="50 - (getValue(formModel.fieldData['ids'][0]) / 2) + '%'">{{getValue(formModel.fieldData['ids'][1])}} %</span>
        </div>
        <div class="slider">
          <mat-slider class="square-knob" min="0" max="100" step="5" #ngSlider>
            <input matSliderThumb
                   [id]="formModel.id"
               [value]="form.controls[formModel.fieldData['ids'][0]].value"
               (input)="onSliderClick();
               setValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}.value, formModel.fieldData['ids'][0]);
               setValue(100 - {source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}.value, formModel.fieldData['ids'][1])" #ngSliderThumb="matSliderThumb"
            />
          </mat-slider>
          <input type="hidden" [formControlName]="formModel.fieldData['ids'][0]" [required]="formModel.isRequired()">
          <input type="hidden" [formControlName]="formModel.fieldData['ids'][1]" [required]="formModel.isRequired()">
        </div>
        <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
      </div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'slider'">
      <label [for]="formModel.id" >{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div class="slider-wrapper" [class.presetted]="formModel.getPresetMark()">
        <div class="slider">
          <mat-slider class="round-knob" [min]="formModel.fieldData.min" [max]="formModel.fieldData.max" [step]="formModel.fieldData.step" #ngSliderParent [discrete]="form.get(formModel.id).value" [displayWith]="formatThumbLabel">
            <input matSliderThumb
                   [id]="formModel.id"
                   [value]="form.get(formModel.id).value"
                   (input)="setValue({source: ngSliderThumbValue, parent: ngSliderParent, value: ngSliderThumbValue.value}.value, formModel.id)"
                   #ngSliderThumbValue="matSliderThumb"
            />
          </mat-slider>
          <div class="min-max-values">
            <span class="min-value">{{ formModel.fieldData.min }} {{ ('unit.' + formModel.getUnit()) | translate}}</span>
            <span class="max-value">{{ formModel.fieldData.max }} {{ ('unit.' + formModel.getUnit()) | translate}}</span>
          </div>
        </div>

        <app-formfield-presetmark [formModel]="formModel" [onClick]="everyFocus" [noClick]="inlineHelp"></app-formfield-presetmark>
      </div>
      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>

    </ng-container>



    <ng-container *ngSwitchCase="'combine'">
      <strong class="input-group-headline">{{ getLabel() | translate }}</strong>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <ng-container *ngFor="let field of formModel.fieldData['fields']">
        <div formfield [inlineHelp]="inlineHelp" [form]="form" *ngIf="field.isActive()" [formModel]="field" [formConfig]="formConfig" [step]="step" class="formfield-subfield"></div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'roofpitch'">
      <label [id]="formModel.id + '_label'">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div app-formfield-roofpitch [formModel]="formModel" [form]="form" [step]="step" [fieldType]="formModel.fieldData.fieldType"></div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <ng-container *ngSwitchCase="'direction'">
      <label [id]="formModel.id + '_label'">{{ getLabel() | translate }}{{getExtraLabelText() | translate}}</label>
      <p *ngIf="teaserTextkey" [innerHTML]="teaserTextkey | translate"></p>
      <div app-formfield-direction [formModel]="formModel" [form]="form" [step]="step" [roofType]="formModel.fieldData.fieldType"></div>

      <app-info-callout [formModel]="formModel" *ngIf="formModel.hasInfotext() && inlineHelp === true" [show]="showInlineHelp" [fieldNamePostfix]="formConfig.getInfoPostfix(formModel.id)"></app-info-callout>
    </ng-container>

    <p class="toggle" *ngIf="formModel.hasToggle">{{step + '.' + formModel.id + '.toggle' | translate}} <button type="button" class="toggle" [attr.aria-controls]="formModel.id" (click)="formConfig.hideField(formModel)">{{'fieldtoggle.pleaseclick' | translate}}</button></p>
  </div>

  <div role="alert" class="error-message error-message-{{formModel.id}}" [innerHTML]="getError() | translate: getErrorPlaceholder()" [class.show]="isInvalid()" [class.warning]="isWarning()" *ngIf="formModel.type != 'combine'"></div>
</ng-container>
